import { routePaths } from './route-paths';

export const PreviousReturnsRedirect = {
  return_for: {
    path: `${routePaths.itrProfile}/${routePaths.personalDetails}`,
    outletPath: `${routePaths.marital}`,
    isEdit: false
  },
  marital_status: {
    path: `${routePaths.itrProfile}/${routePaths.personalDetails}`,
    outletPath: `${routePaths.dependents}`,
    isEdit: false
  },
  background: {
    path: `${routePaths.itrProfile}/${routePaths.personalDetails}`,
    outletPath: `${routePaths.completeDetails}`,
    isEdit: false
  },
  profile: {
    path: `${routePaths.itrProfile}/${routePaths.mailingDetails}`,
    outletPath: ``,
    isEdit: false
  },
  mailing_detail: {
    path: `${routePaths.itrProfile}/${routePaths.mailingDetails}`,
    outletPath: ``,
    isEdit: false
  },
  business1: {
    path: `${routePaths.itrProfile}/${routePaths.mailingDetails}`,
    outletPath: ``,
    isEdit: false
  },
  business2: {
    path: `${routePaths.itrProfile}/${routePaths.busniessDetails}`,
    outletPath: `${routePaths.businessExpenses}`,
    isEdit: false
  },
  business3: {
    path: `${routePaths.itrProfile}/${routePaths.infoSummary}`,
    outletPath: ``,
    isEdit: false
  },
  income: {
    path: `${routePaths.itrSlips}/itrId/rrsp`,
    outletPath: ``,
    isEdit: false
  },
  rrsp: {
    path: `${routePaths.itrSlips}/itrId/deduction`,
    outletPath: ``,
    isEdit: false
  },
  deduction: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.provincialInfo}`,
    outletPath: ``,
    isEdit: false
  },
  provincial_profile: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.propertyTax}`,
    outletPath: ``,
    isEdit: false
  },
  homeowner_property: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.propertyTax}`,
    outletPath: ``,
    isEdit: false
  },
  qualify_tb: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.trilliumBenfit}`,
    outletPath: ``,
    isEdit: false
  },
  residence_payment: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.paymentInfo}`,
    outletPath: ``,
    isEdit: false
  },
  apply_tb: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.trilliumBenefitApply}`,
    outletPath: ``,
    isEdit: false
  },
  t_slip: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.tSlip}`,
    outletPath: ``,
    isEdit: false
  },
  employment_tc: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.employmentTax}`,
    outletPath: ``,
    isEdit: false
  },
  training_tc: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.trainingTax}`,
    outletPath: ``,
    isEdit: false
  },
  education_tc: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.educationTax}`,
    outletPath: ``,
    isEdit: false
  },
  opportunities_fund: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.opportunitiesFund}`,
    outletPath: ``,
    isEdit: false
  },
  climate_action_incentive: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.climateIncentive}`,
    outletPath: ``,
    isEdit: false
  },
  credits_for_cai: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.creditsForCai}`,
    outletPath: ``,
    isEdit: false
  },
  credits_na_cai: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.creditNaForCai}`,
    outletPath: ``,
    isEdit: false
  },
  payment: {
    path: `${routePaths.itrProvincial}/itrId/${routePaths.filingHub}`,
    outletPath: ``,
    isEdit: false
  },
};
